module.exports = __webpack_public_path__ + "static/media/facebook.145f1dba.svg";